// extracted by mini-css-extract-plugin
export default {"container":"sticker_container__rBkxZ","sticker":"sticker_sticker__yMnF2","background":"sticker_background__HltC5","paused":"sticker_paused__+yMOt"};